import { Stack, styled } from "@mui/material"
import { fieldsSpacing } from "../formLayout.const"

export const FieldsColumn = styled(Stack)({})
FieldsColumn.defaultProps = {
  direction: "column",
  spacing: fieldsSpacing,
}
